import React from "react";
import {
  LabelDetail,
  ValueDetail,
  ValueDetailDate,
  ValueDetailUnit,
  ValueImage,
} from "../../../../../component/page-components/detail";
import { licenseType } from "../../../../../util/Util";

const FleetDetailDeliveryAssociate = ({ data, additional_proofs }) => {
  const {
    license_image,
    license_type,
    vehicle_type,
    model,
    vehicle_no,
    temperature_category_name,
    skill_set_name,
    max_order_unit,
    min_order_unit,
    max_order_weight,
    min_order_weight,
    max_order_volume,
    min_order_volume,
    fixed_cost,
    variable_cost,
    transporter_time_cost,
    waiting_time_cost,
    license_id,
    license_number,
    license_validity,
    total_range_distance
  } = data;

  return (
    <>
      <div className=" mt-10 flex flex-col">
        <p className=" font-roboto text-lg text-black-100 font-bold">
          Driver Profile
        </p>
        <div className=" mt-3 flex flex-row">
          <div className=" w-1/3">
            <LabelDetail children="Driver License Photo" />
            <ValueImage sources={license_image} alt="driver-license" />

            <LabelDetail children="License Type" />
            <ValueDetail children={licenseType(license_type)} />
          </div>
          <div className=" w-1/3">
            <LabelDetail children="License ID" />
            <ValueDetail children={license_id ? license_id : "-"} />

            <LabelDetail children="License Number" />
            <ValueDetail children={license_number ? license_number : "-"} />

            <LabelDetail children="Validity Period of Driving License" />
            <ValueDetailDate
              children={license_validity ? license_validity : "-"}
            />

            <LabelDetail children="Vehicle Type" />
            <ValueDetail children={vehicle_type ? vehicle_type : "-"} />
          </div>
          <div className=" w-1/3">
            <LabelDetail children="Model" />
            <ValueDetail children={model ? model : "-"} />

            <LabelDetail children="Vehicle No" />
            <ValueDetail children={vehicle_no ? vehicle_no : "-"} />

            <LabelDetail children="Temperature Category" />
            <ValueDetail
              children={
                temperature_category_name ? temperature_category_name : "-"
              }
            />

            <LabelDetail children="Skillset" />
            <ValueDetail
              children={skill_set_name ? skill_set_name.toString() : "-"}
            />
          </div>
        </div>
        <p className=" font-roboto text-lg text-black-100 font-bold mt-3">
          Order Specification
        </p>
        <div className=" mt-3 flex flex-row">
          <div className=" w-1/3">
            <LabelDetail children="Max Unit" />
            <ValueDetail children={max_order_unit ? max_order_unit : 0} />

            <LabelDetail children="Min Unit" />
            <ValueDetail children={min_order_unit ? min_order_unit : 0} />

            <LabelDetail children="Max Weight" />
            <ValueDetail
              children={max_order_weight ? max_order_weight + " Kg" : "0"}
            />

            <LabelDetail children="Min Weight" />
            <ValueDetail
              children={min_order_weight ? min_order_weight + " Kg" : "0"}
            />
          </div>
          <div className=" w-1/3">
            <LabelDetail children="Max Volume" />
            <ValueDetailUnit
              children={max_order_volume ? max_order_volume : "0"}
            />

            <LabelDetail children="Min Volume" />
            <ValueDetailUnit
              children={min_order_volume ? min_order_volume : "0"}
            />

            <LabelDetail children="Fix Cost" />
            <ValueDetail children={`IDR ${fixed_cost ? fixed_cost : 0}`} />

            <LabelDetail children="Variable Cost Per Km" />
            <ValueDetail
              children={`IDR ${variable_cost ? variable_cost : 0}`}
            />
          </div>
          <div className=" w-1/3">
            <LabelDetail children="Transporter Time Cost" />
            <ValueDetail
              children={`IDR ${
                transporter_time_cost ? transporter_time_cost : 0
              }`}
            />

            <LabelDetail children="Waiting Time Cost" />
            <ValueDetail
              children={`IDR ${waiting_time_cost ? waiting_time_cost : 0}`}
            />
            <LabelDetail children="Total Range Distance" />
            <ValueDetail
              children={`${total_range_distance ? total_range_distance : 0} Km`}
            />
          </div>
        </div>
        {additional_proofs && additional_proofs.length > 0 ? (
          <>
            <p className=" font-roboto text-lg text-black-100 font-bold mt-5">
              Additional Proofs
            </p>
            <div className=" mt-3 flex flex-wrap">
              {additional_proofs.map((item, index) => {
                return (
                  <div className=" w-1/3" key={index}>
                    <LabelDetail children={item.key} />
                    <ValueDetail children={item.value ? item.value : "-"} />
                  </div>
                );
              })}
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default FleetDetailDeliveryAssociate;
